import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { X } from 'lucide-react';
import { Col } from '../../lib/utils';
import { Head4, Body3Bold, Body3Regular, CaptionRegular } from '../../lib/font';
import { colors } from '../../lib/colors';
import InvalidOrderScreen from './components/InvalidOrderScreen';
import PaymentStateScreen from './components/PaymentStateScreen';
import { useGiftPaymentOrder } from './hooks/useGiftPaymentOrder';

const GiftPayFailPage: React.FC = () => {
    const { orderId } = useParams<{ orderId: string }>();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const { order, error, isLoading } = useGiftPaymentOrder(orderId);
    // 토스 결제창 실패 리다이렉트 시 message 쿼리로 사유 전달
    const failMessage = searchParams.get('message');

    if (isLoading) {
        return <PaymentStateScreen title="주문 정보를 불러오고 있어요" />;
    }

    if (!order) {
        return <InvalidOrderScreen message={error?.message} />;
    }

    const handleRetry = () => {
        const rolePath = order.role === 'TRAINER' ? 'trainer' : 'member';
        navigate(`/gift-pay/${rolePath}/${order.orderId}`, { replace: true });
    };

    return (
        <Col style={{ width: '100%', minHeight: '100vh', alignItems: 'center', backgroundColor: '#F5F7FA' }}>
            <Col
                style={{
                    width: '100%',
                    maxWidth: 480,
                    minHeight: '100vh',
                    padding: '0 16px',
                    paddingBottom: 'max(24px, env(safe-area-inset-bottom))',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        width: 64,
                        height: 64,
                        borderRadius: 32,
                        backgroundColor: colors.ERROR_50,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <X size={32} color={colors.ERROR} strokeWidth={3} />
                </div>
                <Head4 style={{ color: colors.LAVEL_4, marginTop: 20 }}>결제가 완료되지 않았어요</Head4>
                <Body3Regular style={{ color: colors.LAVEL_2, marginTop: 8, textAlign: 'center' }}>
                    {failMessage ? (
                        <>
                            {failMessage}
                            <br />
                            잠시 후 다시 시도해 주세요.
                        </>
                    ) : (
                        <>
                            결제가 중단되었거나 카드사 승인이 거절되었어요.
                            <br />
                            잠시 후 다시 시도해 주세요.
                        </>
                    )}
                </Body3Regular>

                <button
                    onClick={handleRetry}
                    style={{
                        width: '100%',
                        height: 52,
                        borderRadius: 12,
                        border: 'none',
                        cursor: 'pointer',
                        backgroundColor: colors.primary,
                        marginTop: 32,
                    }}
                >
                    <Body3Bold style={{ color: '#FFFFFF' }}>다시 시도</Body3Bold>
                </button>
                <CaptionRegular style={{ color: colors.LAVEL_1, marginTop: 12 }}>
                    이 창은 닫으셔도 됩니다
                </CaptionRegular>
            </Col>
        </Col>
    );
};

export default GiftPayFailPage;
